import Button from "@/components/Atoms/Button";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx, handleScrollIntoView } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./WhatMakesShyftBootCampUniqueSection.module.scss";

interface WhatMakesShyftBootCampUniqueSectionProps { }

const WhatMakesShyftBootCampUniqueSection: React.FC<
  WhatMakesShyftBootCampUniqueSectionProps
> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  if (!data?.whatMakesBootCampUniqueSection)
    return <></>

  const isAllPackages = data?.allPackages;

  const { title, featuresSection, hasTwoColumnLayout, isCtaVisible = true, isCustomizationAllowed = false } =
    data?.whatMakesBootCampUniqueSection || {};

  return (
    <section id="WhatMakesShyftBootCampUniqueSection">
      <div className={`${cls("WhatMakesShyftBootCampUniqueSection")} ${isCustomizationAllowed === true ? cls("NewWhatMakesShyftBootCampUnique") : ''}`}>
        <Typography variant="heading6" className={cls("heading")}>
          {title}
        </Typography>
        <div
          className={clsx(
            cls("featuresContainer"),
            hasTwoColumnLayout ? cls("twoColumnLayout") : ""
          )}
        >
          {featuresSection?.map((item: any) => {
            return (
              <div key={item?.icon} className={cls("featureItem")}>
                <div className={`${cls("iconWrapper")} ${isCustomizationAllowed === true ? cls("iconWrapper-display-none") : ''}`}>
                  <SVGSprite icon={item?.icon} />
                </div>
                <div className={cls("textContainer")}>
                  <Typography variant="paragraph4" className={`${cls("title")} ${isCustomizationAllowed === true ? cls("add-margin-left-title") : ''}`}>
                    {item?.title}
                  </Typography>
                  <Typography
                    variant="paragraph4"
                    className={cls("subTitle")}
                    dangerouslySetInnerHTML={{ __html: item?.description }}
                  />
                </div>
              </div>
            );
          })}
        </div>
        {isCtaVisible && isAllPackages && (
          <div className={cls("viewPackages")}>
            <Button
              className={cls("actionButton")}
              onClick={() =>
                handleScrollIntoView({ id: "all-packages-section" })
              }
            >
              View plans
            </Button>
          </div>
        )}
      </div>
    </section >
  );
};

export default WhatMakesShyftBootCampUniqueSection;
